// src/components/ui/Spinner.jsx
import React from "react";

export default function Spinner({ size = 16, className = "" }) {
  return (
    <i
      className={`ti ti-loader-2 spin ${className}`}
      style={{ fontSize: size, color: "inherit" }}
      aria-hidden="true"
    />
  );
}

/**
 * Lightweight inline toast. Pass `tone` and `open` from parent.
 * Sits top-center on the viewport.
 */
export function Toast({ open, tone = "success", message }) {
  if (!open) return null;

  const toneStyles = {
    success: {
      border: "1px solid var(--teal-border)",
      background: "var(--teal-dim)",
      color: "var(--teal)",
      icon: "circle-check",
    },
    error: {
      border: "1px solid var(--red-border)",
      background: "var(--red-dim)",
      color: "var(--red)",
      icon: "alert-circle",
    },
    info: {
      border: "1px solid var(--blue-border)",
      background: "var(--blue-dim)",
      color: "var(--blue)",
      icon: "info-circle",
    },
  }[tone] || {};

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 -translate-x-1/2 top-6 z-[200] fade-in-up"
      style={{
        ...toneStyles,
        padding: "10px 16px",
        borderRadius: "var(--r-lg)",
        backdropFilter: "blur(10px)",
        maxWidth: "92vw",
      }}
    >
      <div className="flex items-center gap-2 text-[13px] font-medium">
        <i className={`ti ti-${toneStyles.icon}`} style={{ fontSize: 16 }} />
        {message}
      </div>
    </div>
  );
}
